export default __webpack_public_path__ + "static/media/Logo.81b124bd.svg";